<template>
  <div class="guide">
    <van-nav-bar title="康塔科技隐私保护指引" left-arrow @click-left="back" />
    <div class="guide_wrap">
      <p>更新日期： 2019年7月26日</p>
      <p>生效日期： 2019年7月26日</p>
      <p>1. 我们收集的信息</p>
      <p>QuantaData综合出入口管理系统是由广州康塔科技有限公司（以下简称“我们”）研发和运营的微信预约平台，在您使用QuantaData综合出入口管理系统服务的过程中，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的账户安全：</p>
      <p>
        <span>•</span>当您使用QuantaData综合出入口管理系统服务时，我们会收集您的头像、姓名、手机号码、公司名称、微信openid，用于标识您为QuantaData综合出入口管理系统的用户。这些信息属于敏感信息，我们会以加密方式存储，并承诺对所收集信息严格保密。
      </p>
      <p>
        <span>•</span>当您使用邀约访客功能时，我们可能因提供该服务所必要收集并向您展示您邀约访客的姓名、手机号码等信息。这些信息属于敏感信息，我们会以加密方式存储，并承诺对所收集信息严格保密。
      </p>
      <p>
        <span>•</span>当您使用前台/自助机访客登记、身份验证、邀约验证服务时，我们会收集您的身份证号码用于登记和判断您是否来访本人，这些信息属于敏感信息，我们会以加密方式存储，并承诺对所收集信息严格保密。
      </p>
      <p>
        <span>•</span> 当您使用QuantaData综合出入口管理系统服务时，我们会收集您的预约记录、邀约记录、审核记录，使您能够查看您的预约/邀约/审核记录。
      </p>
      <p>
        <span>•</span> 我们或我们的第三方合作伙伴可能通过cookie或同类技术收集您的信息，包括您的浏览信息、点击信息，并将该等信息储存为日志信息，用于记住您的身份、分析您使用我们服务的情况、优化广告投放。您可以通过浏览器设置拒绝或管理cookie或同类技术的使用。同时，我们也会使用第三方SDK实现以上采集和使用。
        另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
      </p>
      <p>
        <span>•</span> 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；
      </p>
      <p>
        <span>•</span> 与犯罪侦查、起诉、审判和判决执行等直接相关的；
      </p>
      <p>
        <span>•</span> 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
      </p>
      <p>
        <span>•</span> 所收集的个人信息是您自行向社会公众公开的；
      </p>
      <p>
        <span>•</span> 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
      </p>
      <p>
        <span>•</span> 根据您要求签订和履行合同所必需的；
      </p>
      <p>
        <span>•</span> 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
      </p>
      <p>
        <span>•</span> 为开展合法的新闻报道所必需的；
      </p>
      <p>
        <span>•</span> 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      </p>
      <p>
        <span>•</span> 法律法规规定的其他情形。
      </p>
      <p>请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</p>
      <p>请您注意，目前我们不会主动从广州康塔科技有限公司外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您的个人信息，我们会在获取前向您告知个人信息的来源、类型及使用范围，如我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您该等个人信息前征得您的授权同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。</p>
      <p>2. 信息的存储</p>
      <p>2.1 信息存储的方式和期限</p>
      <p>
        <span>•</span> 我们会通过安全的方式存储您的信息，包括本地存储、数据库和服务器日志。
      </p>
      <p>
        <span>•</span> 一般情况下，我们只会在为实现QuantaData综合出入口管理系统服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。
      </p>
      <p>2.2 信息存储的地域</p>
      <p>
        <span>•</span> 我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。
      </p>
      <p>
        <span>•</span> 目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们会向您告知信息出境的目的、接收方、安全保证措施和安全风险，并征得您的同意。
      </p>
      <p>2.3 产品或服务停止运营时的通知</p>
      <p>
        <span>•</span> 当我们的产品或服务发生停止运营的情况时，我们将以推送通知、公告等形式通知您，并在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。
      </p>
      <p>3. 信息安全</p>
      <p>3.1 安全保护措施</p>
      <p>
        <span>•</span> 我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。
      </p>
      <p>
        <span>•</span> 我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。
      </p>
      <p>
        <span>•</span> 我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。
      </p>
      <p>3.2 安全事件处置措施</p>
      <p>
        <span>•</span> 若发生个人信息泄露、损毁、丢失等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会及时以推送通知、邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
      </p>
      <p>4. 我们如何使用信息</p>
      <p>我们严格遵守法律法规的规定以及与用户的约定，按照本隐私保护指引所述使用收集的信息，以向您提供更为优质的服务。</p>
      <p>4.1 信息使用规则</p>
      <p>我们会按照如下规则使用收集的信息：</p>
      <p>
        <span>•</span> 我们会根据我们收集的信息向您提供各项功能与服务，包括微信访客预约、前台/自助机访客登记、身份验证、邀约验证等服务、通行闸机、门禁、派梯等功能
      </p>
      <p>
        <span>•</span> 我们会根据您使用QuantaData综合出入口管理系统的相关记录分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。
      </p>
      <p>4.2 告知变动目的后征得同意的方式</p>
      <p>
        <span>•</span> 我们将会在本隐私保护指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。
      </p>
      <p>5. 对外提供</p>
      <p>目前，我们不会主动共享或转让您的个人信息至第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意。</p>
      <p>我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。</p>
      <p>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本隐私保护指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。</p>
      <p>另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：</p>
      <p>
        <span>•</span> 与国家安全、国防安全直接相关的；
      </p>
      <p>
        <span>•</span> 与公共安全、公共卫生、重大公共利益直接相关的；
      </p>
      <p>
        <span>•</span> 与犯罪侦查、起诉、审判和判决执行等直接相关的；
      </p>
      <p>
        <span>•</span> 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </p>
      <p>
        <span>•</span> 个人信息主体自行向社会公众公开个人信息的；
      </p>
      <p>
        <span>•</span> 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      </p>
      <p>6. 变更</p>
      <p>我们可能会适时对本隐私保护指引进行修订。当隐私保护指引的条款发生变更时，我们会在版本更新时以红点提示等方式向您提示变更后的隐私保护指引，并向您说明生效日期。请您仔细阅读变更后的隐私保护指引内容，您继续使用QuantaData综合出入口管理系统表示您同意我们按照更新后的隐私保护指引处理您的个人信息。</p>
      <p>7. 其他</p>
      <p>《康塔科技隐私保护指引》是广州康塔科技有限公司统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用QuantaData综合出入口管理系统用户。</p>
      <p>8. 联系我们</p>
      <p>当您有其他的投诉、建议、未成年人个人信息相关问题或需要删除所有访问记录时， 请通过 http://www.QuantaData.cn/与我们联系。您也可以将您的问题发送至kt@QuantaData.cn</p>
      <p>我们将尽快审核所涉问题，并在验证您的用户身份后的三十天内予以回复。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Guide',
  created() {

  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}

</script>

<style lang="less" scoped>
.guide {
  .guide_wrap {
    width: 87%;
    background: #fff;
    margin: 0.12rem auto;
    padding: 0.12rem 0.15rem;
    p {
      font-size: 0.12rem;
      color: #333;
      line-height: 0.2rem;
      span {
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
